import { render } from "./Waiting3.vue?vue&type=template&id=28393ef8"
import script from "./Waiting3.vue?vue&type=script&lang=js"
export * from "./Waiting3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__